import { z } from 'zod'

const LoginSchema = z.object({
  mode: z.string(),
  supportEmail: z.boolean(),
  supportPhone: z.boolean(),
  termsAndConditions: z.string(),
  magicLink: z.boolean()
})

const VideoSchema = z.object({
  controls: z.boolean(),
  allowSkip: z.boolean()
})

const FacesSchema = z.object({
  video: VideoSchema
})

const HeaderFooterSchema = z.object({
  inventory: z.boolean(),
  map: z.boolean(),
  scanner: z.boolean(),
  ar: z.boolean(),
  activity: z.boolean().optional(),
  profile: z.string().optional(),
  logo: z.boolean().optional(),
  category: z.boolean().optional(),
  search: z.boolean().optional(),
  sort: z.boolean().optional()
})

const InventorySchema = z.object({
  fqdn_whitelist: z.array(z.string()),
  tv_blacklist: z.array(z.string()),
  object_definition_blacklist: z.array(z.string()),
  splashContent: z.boolean(),
  pinned: z.array(z.string()).optional()
})

const VatomSchema = z.object({
  closeToInventory: z.boolean()
})

const LoginPopupSchema = z.object({
  supportsVerify: z.boolean()
})

const ClaimSchema = z.object({
  renderClaimPage: z.boolean()
})

const IncomingOverlaySchema = z.object({
  enabled: z.boolean()
})

const ARSchema = z.object({
  visibleRadius: z.number(),
  maxItems: z.number(),
  resizeObjects: z.boolean(),
  desiredRadius: z.number(),
  scalingStrategy: z.string(),
  distanceFromCamera: z.number(),
  objectBaseHeight: z.number(),
  minDistance: z.number(),
  additionalRandomDistance: z.number(),
  ambientLightColor: z.string()
})

const VersionSchema = z.object({
  recommended: z.string(),
  minimum: z.string(),
  link: z.string()
})

const AppConfigurationSchema = z.object({
  appID: z.string(),
  appTitle: z.string(),
  viewerId: z.string(),
  features: z.object({
    login: LoginSchema,
    faces: FacesSchema,
    header: HeaderFooterSchema,
    footer: HeaderFooterSchema,
    inventory: InventorySchema,
    vatom: VatomSchema,
    loginPopup: LoginPopupSchema,
    claim: ClaimSchema,
    incomingOverlay: IncomingOverlaySchema,
    fullScreenScroll: z.boolean(),
    campaignHeader: z.boolean(),
    ar: ARSchema
  }),
  browserCompatbilityRegexes: z.array(z.string()),
  versions: z.object({
    ios: VersionSchema,
    android: VersionSchema
  })
})

type AppConfig = z.infer<typeof AppConfigurationSchema>

export {
  AppConfig,
  AppConfigurationSchema
  // You can also export individual schemas if they're needed separately.
}
